import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { setDefaultSetting } from "../store";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import { getTag } from "@pages/SettingGeneral/SaleSupport/SaleSupportFranchise/helper";

export function useSyncDefaultSettingSaleSupport(
    data: any,
    defaultSetting: any
) {
    useEffect(() => {
        if (data.data === undefined) return;
        setDefaultSetting({
            ...defaultSetting,
            saleSupport: { data: [...data.data] },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
}

export function useInitSaleSupportUrl(
    franchiseID: string,
    setUrl: (url: string) => void
) {
    useEffect(() => {
        setUrl(
            `${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/getData?type=saleSupport&franchiseId=${franchiseID}`
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

export function useInitSaleSupportForm(
    saleSupport: any,
    i18nextLng: string,
    setTitle: (val: string) => void,
    setDisplayName: (val: string) => void,
    setTagsData: (val: any) => void,
    setSaleSupportLabel: (val: string) => void,
    setAdvancedDisplayName: (val: any) => void
) {
    const { t } = useTranslation();

    useEffect(() => {
        clearData();
        setTitle(t("Modify a sale support"));
        setDisplayName(saleSupport.advancedDisplayName.languages[i18nextLng]);
        setTagsData(saleSupport.Tag.split(","));
        setSaleSupportLabel(t(saleSupport.support_de_vente));
        setAdvancedDisplayName(saleSupport.advancedDisplayName);

        // eslint-disable-next-line
    }, [saleSupport, t]);
}

export function useFetchSaleSupportData(
    saleSupport: any,
    userID: string,
    shopID: string,
    franchiseID: string,
    setTags: (val: any[]) => void,
    getGeneralSaleSupport: () => void,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    useEffect(() => {
        getGeneralSaleSupport();
        getTag(userID, shopID, franchiseID, setTags, fetchGlobal);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saleSupport]);
}
